module.exports = __webpack_public_path__ + "img/guide2.6faf0453.png";